import React, { Fragment } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import NewsFreedsCreator from "@c/news-freeds-view/news-freeds-creator/NewsFreedsCreator";
import { ModalBackDrop } from "static/styled/ModalBackDrop.styled";

export const Routes = function({ location }) {
  return (
    <Switch location={location}>
      <Route
        path={"/news-freads/:gradeLevel/:level/create"}
        render={props => (
          <Fragment>
            <NewsFreedsCreator {...props} />
            <ModalBackDrop active second />
          </Fragment>
        )}
      />
      <Route
        path={"/news-freads/:gradeLevel/:level/edit/:id"}
        render={props => (
          <Fragment>
            <NewsFreedsCreator {...props} />
            <ModalBackDrop active second />
          </Fragment>
        )}
      />
    </Switch>
  );
};

export default withRouter(Routes);
